const travellers = {
  title: "Travelers' date of birth?",
  modal: {
    title: 'Edit travelers details.',
    actions: {
      save: 'Update',
    },
  },
  primaryTraveller: {
    title: 'Primary Traveler',
  },
  input: {
    label: 'Date of birth',
    placeholder: 'MM/DD/YYYY',
  },
  maxTravellersModal: {
    title: 'Maximum number of travelers.',
    content:
      'Unfortunately, we only support up to {{maxSecondaryTravellers}} additional travelers per policy. You can always get two different policies if you wish to add more.',
    actions: {
      ok: 'Ok, got it',
    },
  },
  additionalTravellers: {
    title: 'Additional travelers',
    actions: {
      add: 'Add',
      remove: 'Remove',
    },
  },
} as const;

export default travellers;
